import SplitPayPlaceOrder from './SplitPayPlaceOrder';

export default SplitPayPlaceOrder;
